import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

function padNumber(value: number | null) {
    if (value !== null && !Number.isNaN(value)) {
        return `0${value}`.slice(-2);
    } else {
        return '';
    }
}

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct | null {
        if (value) {
            const [dayStr, monthStr, yearStr] = value.trim().split('/');
            return {
                day: parseInt(dayStr, 10) || 0,
                month: parseInt(monthStr, 10) || 0,
                year: parseInt(yearStr, 10) || 0,
            };
        }
        return null;
    }

    format(date: NgbDateStruct | null): string {
        return date ?
            `${padNumber(date.day)}/${padNumber(date.month)}/${date.year || ''}` :
            '';
    }

    format_dash(date: NgbDateStruct | null): string {
        return date ?
            `${date.year || ''}-${padNumber(date.month)}-${padNumber(date.day)}` :
            '';
    }
}
